// Each tab holds its access token in memory only, but the server's single-session rule
// (JWTDecodedListener) rejects any token older than the newest one issued to the user once
// that newer one is 60 seconds old. So a reload, a new tab or an unlock in one tab used to
// lock every other tab of the same browser as if another device had signed in (#6257).
// Tabs pass each newly issued token to one another over this channel instead. A
// BroadcastChannel stays in memory and reaches only same-origin tabs of this browser, so
// the token is still never written to storage.

const CHANNEL_NAME = 'bn-auth-token';

// One instance both posts and listens: a channel never delivers to the instance that
// posted, so a tab does not receive its own token back.
let channel;

function getChannel() {
    if (channel === undefined) {
        channel = typeof BroadcastChannel === 'function' ? new BroadcastChannel(CHANNEL_NAME) : null;
    }
    return channel;
}

export function shareAuthToken(token) {
    try {
        getChannel()?.postMessage({ token });
    } catch (error) {
        // Sharing is best effort: a tab that misses the token keeps its own until it refreshes.
        console.error('Failed to share the auth token with other tabs:', error);
    }
}

/**
 * @param {(token: string) => void} handler - Receives each token another tab shares.
 * @returns {() => void} Stops listening.
 */
export function onSharedAuthToken(handler) {
    const ch = getChannel();
    if (!ch) return () => {};

    const listener = (event) => {
        if (typeof event.data?.token === 'string') {
            handler(event.data.token);
        }
    };
    ch.addEventListener('message', listener);
    return () => ch.removeEventListener('message', listener);
}
